"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Quest = function Quest(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.12 8.76a3.241 3.241 0 00-3.117 3.355 3.241 3.241 0 003.354 3.115 3.201 3.201 0 001.791-.628l-.496-.362a.174.174 0 00-.187-.011c-.381.215-.821.335-1.293.324A2.522 2.522 0 01.727 12.16a2.51 2.51 0 015.011-.297 2.5 2.5 0 01-.43 1.59.179.179 0 00.042.246l.418.307c-.003.003-.09.123-.28.299-.192.178-.34.295-.34.295l.541.416c.068.052.161.052.227-.002a4.498 4.498 0 00.389-.371.183.183 0 00-.028-.272l-.506-.369c.48-.604.73-1.348.702-2.125A3.241 3.241 0 003.119 8.76zm18.112.687v1.293h-.271a.202.202 0 00-.203.201v.414h.474v2.28c0 1.087.553 1.6 1.485 1.6.53 0 .959-.184 1.283-.43l-.22-.358a.186.186 0 00-.25-.062 1.544 1.544 0 01-.759.209c-.502 0-.859-.297-.859-.973v-2.266h1.156a.173.173 0 00.174-.173v-.442h-1.33V9.63a.18.18 0 00-.182-.182h-.498zM7.438 10.74c-.1 0-.18.08-.18.18v2.432c0 1.283.917 1.89 1.963 1.89 1.04 0 1.965-.607 1.965-1.89v-2.436a.175.175 0 00-.176-.176h-.51v2.547c0 .895-.54 1.315-1.28 1.315s-1.283-.42-1.283-1.315V10.74h-.5zm6.605 0c-1.233 0-2.147.922-2.147 2.246 0 1.338.91 2.248 2.188 2.248.635 0 1.238-.16 1.777-.675l-.257-.329a.167.167 0 00-.235-.03c-.347.273-.769.435-1.244.435-.781 0-1.433-.479-1.53-1.41h3.288a.192.192 0 00.191-.188l.002-.068c-.01-1.316-.86-2.229-2.033-2.229zm4.414 0c-1.037 0-1.727.493-1.727 1.31 0 .645.457 1.077 1.43 1.196l.516.06c.612.074.904.283.904.63 0 .456-.462.699-1.193.699-.617 0-1.024-.152-1.334-.354a.196.196 0 00-.274.063l-.205.332c.548.415 1.248.553 1.805.553 1.165 0 1.904-.516 1.904-1.338 0-.708-.535-1.087-1.453-1.205l-.512-.065c-.566-.068-.88-.247-.88-.607 0-.42.406-.68 1.023-.68.492 0 .961.152 1.264.314a.18.18 0 00.242-.07l.123-.219a.18.18 0 00-.07-.244c-.408-.227-.962-.375-1.563-.375zm-4.428.602c.736 0 1.265.521 1.352 1.33h-2.776c.11-.781.625-1.33 1.424-1.33Z"
  }));
};

Quest.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Quest.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Quest;
exports["default"] = _default;